const carousels = async function () {
    const latestNewsCarousel = [...document.querySelectorAll(".latest-news")];
    const heroCarousel = [...document.querySelectorAll(".hero-carousel")];

    const formatter = Intl.NumberFormat('us-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
    });

    if (latestNewsCarousel || heroCarousel) {
        const Swiper = await (await import("swiper/bundle")).default;
        
        if (heroCarousel) {
            heroCarousel.forEach(section => {
                let timeOut = null;
                const timeline = section.querySelector(".timeline");
                const title = section.querySelector(".hero-carousel__title");
                
                const carouselBg = new Swiper(section.querySelector(".bg-carousel"), {
                    slidesPerView: 1,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    allowTouchMove: false,
                    simulateTouch: false,
                })

                const carouselContent = new Swiper(section.querySelector(".content-carousel"), {
                    slidesPerView: 1,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    allowTouchMove: false,
                    simulateTouch: false,
                    navigation: {
                      prevEl: section.querySelector(".swiper-button-prev"),  
                      nextEl: section.querySelector(".swiper-button-next"),  
                    },
                    pagination: {
                        el: section.querySelector('.swiper-pagination'),
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            return formatter.format(current) + ' / ' + formatter.format(total);
                        }
                    },
                    on: {
                        init: updateCurrentSlide,
                        slideChange: updateCurrentSlide,
                    }
                })


                function updateTimeline(time) {
                    timeline.style.transitionDuration = `${time}s`;
                    timeline.style.width = "100%";

                    clearTimeout(timeOut);
                    timeOut = setTimeout(() => {
                        const isLastSlide = carouselContent.activeIndex === carouselContent.slides.length - 1;

                        if (!isLastSlide) {
                            carouselContent.slideNext();
                        } else {
                            carouselContent.slideTo(0, 0);
                        }
                    }, time * 1000);
                }


                function updateCurrentSlide(swiper) {
                    // clear timeline
                    clearTimeout(timeOut);
                    timeline.style.setProperty("transition-duration", "0s", "important");
                    timeline.style.width = 0;
                    
                    // set title
                    title.innerText = swiper.slides[swiper.activeIndex].dataset.title;
                    
                    // pause previous video
                    if ( swiper.previousIndex ) {
                        const video = carouselBg.slides[swiper.previousIndex].querySelector("video");
                        video.pause();
                        video.currentTime = 0;
                    }
                    
                    // set current video
                    const video = carouselBg.slides[swiper.activeIndex].querySelector("video");
                    if ( video ) {
                        video.setAttribute("src", video.dataset.src ?? "");
                        video.play().then(() => {
                            carouselBg.slides[swiper.activeIndex].querySelector(".video-poster")?.remove();
                            updateTimeline(video.duration);
                        }).catch((e) => {});
                    }
                    else {
                        updateTimeline(5);
                    }
                    
                    // loading next video
                    const nextVideo = carouselBg.slides[swiper.activeIndex + 1]?.querySelector("video");
                    if ( nextVideo ) nextVideo.setAttribute("src", nextVideo.dataset.src ?? "");
                }
                
                carouselBg.controller.control = carouselContent;
                carouselContent.controller.control = carouselBg;

                // Refresh carousel when user leave tab
                document.addEventListener("visibilitychange", () => {
                    if (document.visibilityState === "visible" && getComputedStyle(timeline).transitionDuration === "0s") {
                        const currentIndex = carouselContent.activeIndex;
                        const nextIndex = (currentIndex + 1) % carouselContent.slides.length;
                        carouselContent.slideTo(nextIndex, 0);
                    }
                });
            })
        }
        
        if (latestNewsCarousel) {
            latestNewsCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    slidesPerView: 1.1,
                    spaceBetween: 20,
                    pagination: {
                        el: section.querySelector(".swiper-pagination"),
                        type: 'custom',
                        renderCustom: function (swiper, current, total) {
                            return `<span>${String(current).padStart(2, "0")} / ${String(total).padStart(2, "0")} </span>`;
                        }
                    },
                    scrollbar: {
                        el: section.querySelector(".latest-news-scrollbar"),
                        draggable: true,
                    },
                    navigation: {
                        prevEl: section.querySelector(".swiper-button-prev"),
                        nextEl: section.querySelector(".swiper-button-next"),
                    },
                    breakpoints: {
                        480: {
                            slidesPerView: 1.5,
                        },
                        640: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 2.5,
                        },
                        1280: {
                            slidesPerView: 3,
                        }
                    }
                })
            })
        }
    }
}

export const init = carousels;